export function isEnabledClientRoute(url) {
  if (url.startsWith("/plus")) return true;

  // Turn off all the client side routing by default in case for v1 page routing
  return false;
}